import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import Dropdown from './Dropdown';
export default React.memo(function MoreMenu({ button, buttonRef, options, position, openClass = 'open', dataOnboardingUid, className = '', detectMobile, backgroundComponentRef, }) {
    const _buttonRef = React.useRef(null);
    const dropdownRef = React.useRef(null);
    const [showList, setShowList] = React.useState(false);
    const [dropdownLeft, setDropdownLeft] = React.useState(null);
    const [dropdownTop, setDropdownTop] = React.useState(null);
    const [dropdownRight, setDropdownRight] = React.useState(null);
    const [dropdownBottom, setDropdownBottom] = React.useState(null);
    React.useEffect(() => {
        var _a, _b, _c;
        const onClickBackground = (evt) => {
            var _a, _b, _c;
            if (!((_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.contains(evt.target)) &&
                !((_b = _buttonRef === null || _buttonRef === void 0 ? void 0 : _buttonRef.current) === null || _b === void 0 ? void 0 : _b.contains(evt.target)) &&
                !((_c = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) === null || _c === void 0 ? void 0 : _c.contains(evt.target))) {
                setShowList(false);
            }
        };
        const onScroll = () => {
            setShowList(false);
        };
        (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('click', onButtonClick);
        (_b = backgroundComponentRef === null || backgroundComponentRef === void 0 ? void 0 : backgroundComponentRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('click', onClickBackground);
        (_c = backgroundComponentRef === null || backgroundComponentRef === void 0 ? void 0 : backgroundComponentRef.current) === null || _c === void 0 ? void 0 : _c.addEventListener('scroll', onScroll);
        return () => {
            var _a, _b, _c;
            (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', onButtonClick);
            (_b = backgroundComponentRef === null || backgroundComponentRef === void 0 ? void 0 : backgroundComponentRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('click', onClickBackground);
            (_c = backgroundComponentRef === null || backgroundComponentRef === void 0 ? void 0 : backgroundComponentRef.current) === null || _c === void 0 ? void 0 : _c.removeEventListener('scroll', onScroll);
        };
    }, [button, backgroundComponentRef]);
    React.useEffect(() => {
        var _a;
        const { width: buttonWidth, height: buttonHeight, top: buttonTop, bottom: buttonBottom, left: buttonLeft, right: buttonRight } = (_a = _buttonRef === null || _buttonRef === void 0 ? void 0 : _buttonRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        const vOffset = 8;
        const hOffset = 8;
        switch (position) {
            case 'top-left': {
                setDropdownBottom(window.innerHeight - buttonTop + vOffset);
                setDropdownRight(window.innerWidth - buttonRight);
                break;
            }
            case 'start-left': {
                setDropdownTop(buttonTop + vOffset);
                setDropdownRight(window.innerWidth - buttonRight);
                break;
            }
            case 'bottom-left': {
                setDropdownTop(buttonBottom + vOffset);
                setDropdownRight(window.innerWidth - buttonRight);
                break;
            }
            case 'top-right': {
                setDropdownBottom(window.innerHeight - buttonTop + vOffset);
                break;
            }
            case 'bottom-right': {
                setDropdownTop(buttonBottom + vOffset);
                break;
            }
        }
    }, [showList]);
    const onButtonClick = (evt) => {
        var _a;
        if (!((_a = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) === null || _a === void 0 ? void 0 : _a.contains(evt.target))) {
            setShowList(prev => !prev);
        }
    };
    const Button = React.useMemo(() => {
        let className = button.props.className;
        if (showList)
            className = `${className} ${openClass}`.trim();
        return React.cloneElement(button, { className });
    }, [showList]);
    return (_jsxs(Container, { className: `${className} ui-more-menu`, children: [_jsx("div", { ref: _buttonRef, onClick: onButtonClick, "data-onboarding-uid": dataOnboardingUid, children: Button }), _jsx(Dropdown, { visible: showList, options: options, left: dropdownLeft, right: dropdownRight, top: dropdownTop, bottom: dropdownBottom, onClose: () => setShowList(false), detectMobile: detectMobile, ref: dropdownRef })] }));
});
const Container = styled.div `
  position: relative;
`;
